import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
	sectionTitle: {
		id: 'home.for-you.rovo-agents-for-you.section-title',
		defaultMessage: 'Rovo Agents for you',
		description:
			'Header for the "Rovo Agents for you" section on Confluence Home / For You, which surfaces recommended AI agent cards',
	},
	labsLozenge: {
		id: 'home.for-you.rovo-agents-for-you.labs-lozenge',
		defaultMessage: 'Labs',
		description:
			'Label on a lozenge indicating the "Rovo Agents for you" feature is part of the early-access Labs program',
	},
});
